// Shared decision for a paged-but-locally-revealed lot-history list. Both the
// home "Recent wins" and the profile "Your lots" reveal a growing slice of an
// already-loaded set, and only hit the network once the slice outruns the cache.
// `shownCount` is owned outside the list (App), so it survives a drill-down into
// a lot and resets on a section change.
export type HistoryView = {
  // How many items to actually render (never more than what's loaded).
  visibleCount: number;
  // Whether a "Show N more" affordance should be offered.
  canShowMore: boolean;
  // Whether the slice has outrun the cache and the next page must be fetched.
  shouldFetchNext: boolean;
};

export function historyView({
  shownCount,
  loadedCount,
  total,
  hasNextPage,
}: {
  shownCount: number;
  loadedCount: number;
  total: number;
  hasNextPage: boolean;
}): HistoryView {
  const visibleCount = Math.min(shownCount, loadedCount);
  return {
    visibleCount,
    // Offer "show more" only when something more is actually reachable: fewer
    // than the total are on screen AND there are either cached-but-hidden items
    // or another page to fetch. Keying off `visibleCount` (not the raw intent
    // `shownCount`) keeps the affordance through the final fetch and never leaves
    // a dead button when `total` overstates the paginable set.
    canShowMore: visibleCount < total && (loadedCount > visibleCount || hasNextPage),
    shouldFetchNext: shownCount > loadedCount && hasNextPage,
  };
}
